import { sortDates } from 'common/utils';
import { AiVariant, AiVariantMap, MelFields } from 'modules/mel-ai/types';
import { Dispatch, SetStateAction, useMemo } from 'react';

import { FaqsVariantMap } from './faqs-variant-map';
import { ProsVariantMap } from './pros-variant-map';
import { VariantItemWrapper } from './variant-item-wrapper';
import styles from './variant-map.module.scss';

interface VariantMapProps {
  currentFieldName: MelFields;
  isFaqs?: boolean;
  isPros?: boolean;
  isString?: boolean;
  selectedVariantState: [AiVariant | null, Dispatch<SetStateAction<AiVariant | null>>];
  variantsMap: AiVariantMap;
}

const VariantMap = ({
  currentFieldName,
  isFaqs,
  isPros,
  isString,
  selectedVariantState,
  variantsMap,
}: VariantMapProps) => {
  const variants = useMemo(
    () =>
      variantsMap[currentFieldName].sort((cur, nxt) =>
        sortDates(cur.created_at, nxt.created_at, 'asc'),
      ),
    [variantsMap, currentFieldName],
  );

  return (
    <div className={styles.container}>
      {isFaqs && (
        <FaqsVariantMap selectedVariantState={selectedVariantState} variants={variantsMap.faqs} />
      )}
      {isPros && (
        <ProsVariantMap selectedVariantState={selectedVariantState} variants={variantsMap.pros} />
      )}
      {isString && (
        <>
          {variants.map((item) => (
            <VariantItemWrapper
              key={item.id}
              selectedVariantState={selectedVariantState}
              variant={item}
            >
              {item.value}
            </VariantItemWrapper>
          ))}
        </>
      )}
    </div>
  );
};

export { VariantMap };
